import React, { Component } from "react";
import { Base } from "zina-dogi-react";
import { CMNReportComponent } from "../components";

class CMNReportContainer extends Component {
    render() {
        const { extraProps } = this.props;
        const base_op = {
            className: "CMN spent report",
            title: "CMN spent report",
            breadcrumbs: [{ name: "Home", rel: "/", icon: "home" }, { name: "CMN spent report" }],
            extraProps,
            loading: false
        };
        return (
            <Base {...base_op}>
                <CMNReportComponent />
            </Base>
        );
    }
}

export default CMNReportContainer;
